var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.color,"elevation":"2","outlined":_vm.outlined,"close":_vm.close,"close-icon":_vm.close ? 'mdi-close' : ''}},[_vm._v(" "+_vm._s(_vm.capital ? _vm.capitalized(_vm.text) : _vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }